import { Box, Paper, Typography } from "@mui/material";

import Link from "../../../atoms/mui/Link";

const ListItemRow = ({ label, value, href }) => {
  const row = (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="body2" color="textPrimary">
        {label}
      </Typography>
      {value && (
        <Typography variant="body2" color="textSecondary">
          {value}
        </Typography>
      )}
    </Box>
  );

  if (!href) return row;
  return <Link href={href}>{row}</Link>;
};

const ScoutListCard = ({ title, items }) => {
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        maxWidth: 480
      }}
    >
      <Typography variant="subtitle1" color="textPrimary">
        {title}
      </Typography>
      <Box display="flex" flexDirection="column" gap={0.5}>
        {safeItems.map((item, idx) => (
          <ListItemRow
            key={`scout-list-${idx}`}
            label={item.label}
            value={item.value}
            href={item.href}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default ScoutListCard;
